import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const Wyoming = () => {
  const [showCities, setShowCities] = useState(false);

  useEffect(() => {
    // Set document title and meta tags
    document.title = "We Buy Valves Wyoming | Industrial Equipment Buyers Wyoming";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional industrial equipment buyers throughout Wyoming. We buy valves, control systems, and instrumentation from Casper, Cheyenne, and all Wyoming facilities at above scrap rates.');
    }
    
    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'wyoming valve buyers, we buy valves wyoming, industrial equipment buyers wyoming, surplus valve buyers');
    }
    
    // Set canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/wyoming');
    }
    
    // Set Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'We Buy Valves Wyoming | Industrial Equipment Buyers Wyoming');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Professional industrial equipment buyers throughout Wyoming. We buy valves, control systems, and instrumentation from Casper, Cheyenne, and all Wyoming facilities at above scrap rates.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/wyoming');
    }
    
    // Set geo location tags
    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) {
      geoPosition.setAttribute('content', '43.0642;-107.5504');
    }
    
    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) {
      geoRegion.setAttribute('content', 'US-WY');
    }
    
    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) {
      geoPlacename.setAttribute('content', 'Wyoming, United States');
    }
    
    // Set last-modified
    const lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString());
    }

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/wyoming/#webpage",
          "url": "https://valvesalessupply.com/wyoming",
          "name": "Wyoming Industrial Equipment Buyers - ValveSalesSupply",
          "description": "Professional industrial equipment purchasing services throughout Wyoming. Serving Cheyenne, Casper, and oil field operations with above scrap market rates.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Wyoming",
                "item": "https://valvesalessupply.com/wyoming"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/wyoming/#place",
          "name": "Wyoming",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "WY",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 43.0642,
            "longitude": -107.5504
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Wyoming Operations",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "WY",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "serviceArea": {
            "@type": "State",
            "name": "Wyoming",
            "addressRegion": "WY"
          },
          "description": "Professional industrial equipment purchasing services throughout Wyoming, serving oil and gas operations, coal processing facilities, and industrial plants in Cheyenne, Casper, and surrounding areas."
        },
        {
          "@type": "ItemList",
          "name": "Wyoming Cities We Serve",
          "numberOfItems": 2,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Cheyenne",
                "url": "https://valvesalessupply.com/cheyenne"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Casper",
                "url": "https://valvesalessupply.com/casper"
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const wyomingFacilities = [
    { name: 'Casper', facilities: '2+ Refineries', response: '6-8 Hours' },
    { name: 'Sinclair', facilities: '1+ Refinery', response: '7-9 Hours' },
    { name: 'Newcastle', facilities: '1+ Refinery', response: '8-10 Hours' },
    { name: 'Cheyenne', facilities: 'Processing Plants', response: '7-9 Hours' }
  ];

  const wyomingCities = [
    'Casper', 'Cheyenne', 'Laramie', 'Gillette', 'Rock Springs', 'Sheridan', 'Green River', 'Evanston',
    'Riverton', 'Jackson', 'Cody', 'Rawlins', 'Lander', 'Torrington', 'Powell', 'Douglas',
    'Worland', 'Buffalo', 'Thermopolis', 'Wheatland', 'Newcastle', 'Afton', 'Kemmerer', 'Pinedale',
    'Lovell', 'Glenrock', 'Saratoga', 'Star Valley Ranch', 'Lyman', 'Mountain View', 'Sundance', 'Greybull',
    'Moorcroft', 'Lusk', 'Wright', 'Pine Bluffs', 'Guernsey', 'Basin', 'Sinclair', 'Shoshoni'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/c5473a7ea9c3c145468d687aa73fa109.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              We Buy Valves Wyoming
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional surplus equipment buyer serving Wyoming oil refineries and processing facilities. 
              We purchase valves, control systems, and instrumentation from Casper, Sinclair, Newcastle, 
              and throughout Wyoming at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET WYOMING QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Wyoming Market */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">SURPLUS VALVE BUYER WYOMING</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Wyoming's energy sector includes several important refineries and processing facilities that require 
                professional <strong className="text-[#1B3A5F]">surplus equipment removal</strong> services during 
                turnarounds and facility maintenance.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We provide <strong className="text-[#1B3A5F]">industrial equipment buying</strong> services throughout 
                Wyoming, specializing in control valves, Fisher valves, instrumentation, and processing equipment 
                from refineries and industrial facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">5+</div>
                  <div className="text-gray-600">Wyoming Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-10 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">15 Years</div>
                  <div className="text-gray-600">Wyoming Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WYOMING SERVICE AREAS</h3>
              <div className="space-y-4">
                {wyomingFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.facilities}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{facility.response}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment and Services */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY REFINERY EQUIPMENT WYOMING</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Wyoming industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Control Valves</h3>
              <div className="space-y-3">
                {[
                  'Fisher Control Valves',
                  'Masoneilan Valves',
                  'Ball and Gate Valves',
                  'Safety Relief Valves',
                  'Emergency Shutdown Valves'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Instrumentation</h3>
              <div className="space-y-3">
                {[
                  'Rosemount Transmitters',
                  'Flow Measurement Equipment',
                  'Pressure and Temperature Instruments',
                  'Analytical Equipment',
                  'Level Measurement Systems'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Processing Equipment</h3>
              <div className="space-y-3">
                {[
                  'Heat Exchangers',
                  'Pumps and Compressors',
                  'Pressure Vessels',
                  'Separation Equipment',
                  'Control Systems and Panels'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Wyoming Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WHY WYOMING FACILITIES CHOOSE US</h2>
            <p className="text-gray-600 text-xl">Professional equipment removal services tailored to Wyoming's unique challenges</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Weather-Resistant Operations</h3>
              <p className="text-gray-600 mb-6">
                Wyoming's harsh winter conditions require specialized equipment removal expertise. 
                Our teams are experienced in cold-weather operations and understand the unique challenges 
                of working in Wyoming's climate.
              </p>
              <div className="space-y-3">
                {[
                  'Cold-weather equipment removal expertise',
                  'Year-round operational capabilities',
                  'Weather-resistant storage and transport',
                  'Emergency response in harsh conditions'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Wyoming Expertise</h3>
              <p className="text-gray-600 mb-6">
                With 15+ years of experience in Wyoming's energy sector, we understand the specific 
                requirements of refineries and processing facilities throughout the state.
              </p>
              <div className="space-y-3">
                {[
                  '15+ years Wyoming market experience',
                  'Above scrap rates for functional equipment',
                  'Professional documentation and compliance',
                  'Licensed for Wyoming operations'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Major Cities Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Major Cities We Serve in Wyoming
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across Wyoming's key energy markets
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <Link
              to="/casper"
              className="bg-[#F5F7FA] rounded-3xl p-8 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-[#1B3A5F] text-2xl font-bold mb-2">Casper</h3>
                  <p className="text-gray-600 font-semibold">Central Wyoming Energy Hub</p>
                </div>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-3xl group-hover:translate-x-2 transition-transform"></i>
              </div>
              <p className="text-gray-700 mb-4">
                Major oil refining and Powder River Basin operations serving Central Wyoming's energy sector
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Oil Refining</span>
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Gas Processing</span>
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Production</span>
              </div>
            </Link>

            <Link
              to="/cheyenne"
              className="bg-[#F5F7FA] rounded-3xl p-8 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-[#1B3A5F] text-2xl font-bold mb-2">Cheyenne</h3>
                  <p className="text-gray-600 font-semibold">Southeast Wyoming Hub</p>
                </div>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-3xl group-hover:translate-x-2 transition-transform"></i>
              </div>
              <p className="text-gray-700 mb-4">
                Energy infrastructure and industrial facilities serving Southeast Wyoming and regional markets
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Infrastructure</span>
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Manufacturing</span>
                <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-700">Pipelines</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Wyoming Cities Dropdown - Above FAQ */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            <div 
              className="flex items-center justify-between cursor-pointer"
              onClick={() => setShowCities(!showCities)}
            >
              <div>
                <h2 className="text-[#1B3A5F] text-3xl font-bold mb-2">
                  We Buy Surplus Valves in All Wyoming Cities
                </h2>
                <p className="text-gray-600 text-lg">
                  Click to view all {wyomingCities.length}+ Wyoming cities we serve
                </p>
              </div>
              <i className={`ri-arrow-${showCities ? 'up' : 'down'}-s-line text-[#1B3A5F] text-4xl transition-transform`}></i>
            </div>

            {showCities && (
              <div className="mt-8">
                <div className="bg-[#F5F7FA] rounded-2xl p-6 mb-6">
                  <div className="grid md:grid-cols-3 gap-4 text-center">
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">{wyomingCities.length}+ Cities</div>
                      <div className="text-gray-600">Statewide Coverage</div>
                    </div>
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">6-12 Hours</div>
                      <div className="text-gray-600">Average Response Time</div>
                    </div>
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">Same Day</div>
                      <div className="text-gray-600">Equipment Removal Available</div>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-4 gap-4">
                  {wyomingCities.map((city, index) => (
                    <div 
                      key={index}
                      className="bg-[#F5F7FA] rounded-lg p-4 hover:border-2 hover:border-[#14B8A6] transition-all duration-300 cursor-pointer"
                    >
                      <div className="text-[#1B3A5F] font-bold">{city}</div>
                      <div className="text-gray-600 text-sm">We Buy Valves {city} WY</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL SURPLUS VALVES WYOMING</h2>
            <p className="text-gray-200 text-xl">Professional valve buyers serving Wyoming industrial facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WYOMING CONTACT</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">Wyoming Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Lists & Quotes</div>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET WYOMING QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">WYOMING ADVANTAGES</h3>
              <div className="space-y-4">
                {[
                  'Cold-weather operation expertise',
                  'Above scrap rates for quality equipment',
                  'Reliable service across Wyoming',
                  'Professional turnaround coordination',
                  'Emergency equipment removal',
                  '15+ years Wyoming experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Wyoming;
